import React, { MouseEvent, useEffect } from 'react'
import { Handle, Position } from 'reactflow'
import NodeTemplate from '../../base/NodeTemplate'
import { CheckFieldExistConfiguration } from './CheckFieldExistForm'
import { BaseNodeProps } from '../../base/types'

const CheckFieldExistNode = React.memo(
  ({ data, isConnectable }: BaseNodeProps<CheckFieldExistConfiguration>) => {
    const title = 'Rechercher champs existants'
    useEffect(() => {}, [])
    return (
      <>
        <Handle
          type="target"
          position={Position.Left}
          isConnectable={isConnectable}
        />
        <NodeTemplate icon={'filter'} title={title} name={data.name} />
        <Handle
          type="source"
          position={Position.Right}
          id="a"
          isConnectable={isConnectable}
        />
      </>
    )
  }
)

export default CheckFieldExistNode
